import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { fmtMoney } from "@/lib/format";
import { PageHeader } from "@/components/common/Page";
import { KpiCard } from "@/components/common/KpiCard";
import { Loader2 } from "lucide-react";

export default function Gst() {
  const { data, isLoading } = useQuery({ queryKey: ["gst-full"], queryFn: async () => (await api.get("/finance/gst")).data });
  if (isLoading) return <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-cyan-400" /></div>;

  return (
    <div className="ns-fade">
      <PageHeader title="GST" subtitle={`Australian financial year · ${data.period}`} testId="gst-header" />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <KpiCard testId="gst-collected" label="GST Collected" value={fmtMoney(data.gst_collected)} sub="on revenue" accent="cyan" />
        <KpiCard testId="gst-credits" label="GST Credits" value={fmtMoney(data.gst_credits)} sub="on expenses" accent="slate" />
        <KpiCard testId="gst-net" label={data.net_payable >= 0 ? "Net GST Payable" : "Net GST Refundable"} value={fmtMoney(Math.abs(data.net_payable))} accent={data.net_payable >= 0 ? "amber" : "emerald"} />
      </div>
      <div className="mt-6 rounded-xl border border-[#1E2D4A] bg-[#111A2E]/70 p-5 text-sm text-slate-400">
        <div className="mb-2 flex flex-wrap gap-x-8 gap-y-1">
          <span>Financial year: <span className="text-slate-200">{data.fy_start} → {data.fy_end}</span></span>
          <span>GST rate: <span className="text-slate-200">10%</span></span>
        </div>
        <p className="mt-3 rounded-lg border border-amber-500/20 bg-amber-500/5 px-3 py-2 text-[13px] italic text-amber-200/80">
          {data.disclaimer}
        </p>
      </div>
    </div>
  );
}
